import { faCamera, faImage, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClickAwayListener } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import classes from './ImageInput.module.scss';

interface ImageInputProps {
    id: string;
    label: string;
    value?: string;
    maxSize?: number;
    required?: boolean;
    className?: string;
    onChange?: (file: File | undefined, src: string | undefined) => void;
}

export const ImageInput: React.FC<ImageInputProps> = ({ maxSize = 2.5, ...props }) => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const removeImageHandler = () => {
        setIsMenuOpen(false);
        props.onChange?.(undefined, undefined);

        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };

    const editImageHandler = () => {
        inputRef.current?.click();
    };

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (!file) return;

        props.onChange?.(file, URL.createObjectURL(file));
    };

    return (
        <div className={clsx(classes.root, props.className)}>
            <div className={classes.avatarContainer}>
                {props.value ? (
                    <div className={classes.avatar}>
                        <img src={props.value} alt="Pet avatar" className={classes.avatar} />
                        <div className={classes.previewOverlay} onClick={() => setIsMenuOpen(true)}>
                            Edit
                        </div>
                    </div>
                ) : (
                    <label htmlFor={props.id} className={classes.imageIcon}>
                        <FontAwesomeIcon icon={faCamera} />
                    </label>
                )}

                {isMenuOpen && (
                    <ClickAwayListener onClickAway={() => setIsMenuOpen(false)}>
                        <div className={classes.menu}>
                            <button type="button" onClick={editImageHandler}>
                                <FontAwesomeIcon icon={faImage} />
                                Edit
                            </button>
                            <button type="button" onClick={removeImageHandler}>
                                <FontAwesomeIcon icon={faTrash} />
                                Remove
                            </button>
                        </div>
                    </ClickAwayListener>
                )}
            </div>

            <div className={classes.labelContainer}>
                <p className={classes.label}>{props.label}</p>
                <p className={classes.maxSize}>Max size: {maxSize}MB</p>
            </div>

            <input
                type="file"
                accept="image/*"
                id={props.id}
                ref={inputRef}
                required={props.required}
                className={classes.input}
                onChange={changeHandler}
            />
        </div>
    );
};
